export default __webpack_public_path__ + "static/media/SW.7fbc2d10.jpg";